import { TranslateService } from '@ngx-translate/core';

export const getErrorMessage = (
  err: any,
  translateService: TranslateService | null = null
): string => {
  if (!!err?.error?.message) {
    return err.error.message;
  }
  if (!!err?.message) {
    return err.message;
  }
  return !!translateService
    ? translateService.instant('error.message.general')
    : 'An error occurred.';
};
